export default {
  THANKS_POINT_DEFAULT_NAME1: "サンクスポイント",
  THANKS_POINT_DEFAULT_NAME2: "サンクス",
  THANKS_ONLY_POINT_DEFAULT_NAME1: "サンクス専用ポイント",
  THANKS_ONLY_POINT_DEFAULT_NAME2: "サンクス専用"
};
